<template>
    <div :class="`${direction === 'bottom' ? 'tw-flex-col' : 'tw-flex-col-reverse tw-space-y-reverse'}`" class="tw-space-y-2 tw-flex tw-rounded tw-border tw-border-gray-300 tw-bg-white tw-border-solid tw-p-2">
        <div class="tw-grid tw-grid-cols-4 tw-gap-2">
            <div v-for="item in _.take(_.reverse(value),3)" class="tw-bg-primary-500 tw-rounded-sm tw-text-white tw-relative tw-rounded-xs tw-bg-gray-100 tw-px-2 tw-pr-6 tw-truncate">
                <span>{{item.name}}</span>
                <button v-on:click.prevent="remove(item)" class="tw-w-6 tw-flex tw-text-white tw-items-center tw-justify-center tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-bg-transparent tw-border-none">x</button>
            </div>
            <div v-if="value.length > 3" class="tw-rounded-xs tw-px-2 tw-truncate">+{{value.length - 3}} {{$word.more}}</div>
            <div v-if="value.length === 0" class="tw-col-span-4">{{$text.no_countries_selected}}</div>
        </div>
        <multiselect
            v-model="proxyValue"
            label="name"
            track-by="id"
            :placeholder="$text.select_favorite_countries"
            :options="options"
            select-label=""
            deselect-label=""
            selected-label=""
            :open-direction="direction"
            :close-on-select="false"
        >
            <span slot="noResult">{{$text.no_elements_found}}</span>
            <span slot="noOptions">{{$text.enter_something_for_suggestion}}</span>
        </multiselect>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {Multiselect},
        props: {
            direction : {
                default : 'bottom'
            },
            value: {},
        },
        data: v => ({
            countries: [],
        }),
        computed: {
            selectedAll() {
                return this.value.length === this.countries.length
            },
            options() {
                return [
                    {id: 0, name: this.selectedAll ? 'Deselect All' : 'Select all'},
                    ...this.countries.filter(item => !this.optionIsActive(item)),
                ]
            },
            proxyValue: {
                get() {
                    return null
                },
                set(option) {
                    if (option.id === 0) {
                        if (this.selectedAll) {
                            this.$emit('input', [])
                        } else {
                            this.$emit('input', this.countries.filter(item => item.id !== 0))
                        }
                    } else if (this.optionIsActive(option)) {
                        this.$emit('input', this.value.filter(item => item.id !== option.id))
                    } else {
                        this.$emit('input', [...this.value, option])
                    }
                }
            }
        },
        methods: {
            optionIsActive(option) {
                if (option.id === 0 && this.selectedAll) {
                    return true
                }
                return this.value.filter(item => item.id === option.id).length === 1
            },
            remove(option) {
                this.$emit('input', this.value.filter(item => item.id !== option.id))
            }
        },
        created() {
            axios.get("/countries").then(response => {
                this.countries = response.data.data;
            });
        }
    }
</script>
